import {Button, Card, Form, Spinner} from "react-bootstrap";
import React, {Fragment, useContext, useEffect, useState} from "react";
import "react-datepicker/dist/react-datepicker.css";
import "react-datetime/css/react-datetime.css";
import 'react-loading-skeleton/dist/skeleton.css'
import {TsAdminContext} from "../../context/ts-admin";
import Modal from 'react-bootstrap/Modal';
import {toast} from "react-toastify";
import {updateOrg} from "../../api-service/org-info";
import {PageHeader} from "../common/page-header";
import {SettingToggle} from "../common/setting-toggle";
import {CONNECT_TYPE_EX, CONNECT_TYPE_V5, useYupValidationResolver, WorkLocationInterface} from "../../common";
import * as yup from "yup";
import {useFieldArray, useForm} from "react-hook-form";
import {ErrorMessage} from "../../parts/error-message";


const validationSchema = yup.object({
    WorkLocationSetting: yup.object({
        UseIndividualSettings: yup.boolean(),
        WorkLocation: yup.string().trim().when("UseWorkLocation", (isValidate, schema) => {
            console.log("isValidate", isValidate)
            if (isValidate[0] != '0') {
                return schema.transform(value => value === '' ? undefined : value)
                    .max(10, '10文字以内で入力してくだいさい').optional()
            }
            return schema
        })
        ,
        IndividualSettings: yup.array()
            .when(["UseIndividualSettings", "UseWorkLocation"], (isValidate, schema) => {
                console.log("isValidate1", isValidate)
                if (isValidate[0] && isValidate[1] == '1') {
                    return schema.of(yup.object().shape({
                        WorkLocation: yup.string().trim()
                            .transform(value => value === '' ? undefined : value)
                            .max(10, '10文字以内で入力してくだいさい').optional(),
                        DeviceId: yup.string().trim()
                            .transform(value => value === '' ? undefined : value)
                            .required("端末IDを入力してください").matches(/^[a-zA-Z0-9]+$/, '半角英数字で入力してください')
                    }))
                }
                return schema
            })


    })
});

export function TsSettingPage() {
    const [orgInfo, setOrgInfo, userInfo] = useContext(TsAdminContext);
    const [showModalConfirm, setShowModalConfirm] = useState(false);
    const [currentSetting, setCurrentSetting] = useState(0);
    const [showModalConfirmDelete, setShowModalConfirmDelete] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [workLocationExpanded, setWorkLocationExpanded] = useState(true);
    const resolver = useYupValidationResolver(validationSchema);
    const [connectType, setConnectType] = useState<number>();
    const {
        register,
        control,
        handleSubmit,
        reset,
        setValue,
        getValues,
        watch,
        setError,
        clearErrors,
        formState: {isSubmitting, isDirty, isSubmitted, errors}
    } = useForm({
        resolver: resolver,
        defaultValues: {
            CheckIdm: false,
            UseTransportationExpense: true,
            SoundMode: 0,
            // sendEmpCode: false
        }
    });
    const {fields: fieldWorkLocationSetting, append, remove} = useFieldArray({
        control,
        name: "WorkLocationSetting.IndividualSettings",
    });
    const watchUseIndividualSettings = watch("WorkLocationSetting.UseIndividualSettings");

    const watchUseWorkLocation = watch("WorkLocationSetting.UseWorkLocation");
    const watchUseTransportationExpense = watch("UseTransportationExpense");
    const watchCheckIdm = watch("CheckIdm");
    const watchSoundMode = String(watch("SoundMode"));
    const [lastSoundMode, setLastSoundMode] = useState<string>('1');
    useEffect(() => {
        if (watchSoundMode === '1' || watchSoundMode === '2') {
            setLastSoundMode(watchSoundMode);
        }
    }, [watchSoundMode]);
    const setSwitchValue = (name: any, checked: boolean) => {
        setValue(name, (checked ? '1' : '0') as any, {shouldDirty: true});
    };
    const isEx = orgInfo?.currentOrg?.ConnectType == CONNECT_TYPE_EX;
    useEffect(() => {
        clearErrors(`WorkLocationSetting`);
    }, [watchUseWorkLocation]);
    const genDefaultWorkLocationSettings = (providerSetting) => {
        const workLocationSetting: WorkLocationInterface = providerSetting.WorkLocationSetting;
        if (workLocationSetting) {
            return {
                UseWorkLocation: workLocationSetting.UseWorkLocation ? '1' : '0',
                WorkLocation: providerSetting.WorkLocation || '',
                UseIndividualSettings: workLocationSetting.UseIndividualSettings,
                IndividualSettings: workLocationSetting.IndividualSettings
            };
        } else {
            return {
                UseWorkLocation: providerSetting.WorkLocation && providerSetting.WorkLocation != '' ? '1' : '0',
                WorkLocation: providerSetting.WorkLocation || "",
                UseIndividualSettings: false,
                IndividualSettings: [{
                    WorkLocation: "",
                    DeviceId: ""
                }]
            };
        }

    }
    useEffect(() => {
        if (orgInfo) {
            const currentOrg = orgInfo.currentOrg;
            setConnectType(currentOrg.ConnectType);

            console.log(genDefaultWorkLocationSettings(currentOrg.ProviderSetting), "genDefaultWorkLocationSettings(currentOrg.ProviderSetting)")
            reset({
                CheckIdm: orgInfo.currentOrg.CheckIdm ? '1' : '0',
                UseTransportationExpense: orgInfo.currentOrg.UseTransportationExpense ? '1' : '0',
                SoundMode: orgInfo.currentOrg.SoundMode.toString(),
                WorkLocationSetting: genDefaultWorkLocationSettings(currentOrg.ProviderSetting)
            })
        }

    }, [orgInfo])


    const [insertData, setInsertData] = useState<any>();
    const submitFormData = async (data) => {
        const orgInsertData = {
            CheckIdm: data.CheckIdm == 1 ? true : false,
            UseTransportationExpense: data.UseTransportationExpense == 1 ? true : false,
            SoundMode: Number(data.SoundMode),
        }
        const providerSetting = {};
        const workLocationSetting = data.WorkLocationSetting
        if (workLocationSetting.UseWorkLocation == '1') {
            if (workLocationSetting.UseIndividualSettings) {
                const arrSetting = workLocationSetting.IndividualSettings;
                const arrayUniqueByKey = arrSetting.map(item => item.DeviceId)
                    .filter((value, index, self) => self.indexOf(value) === index);
                if (arrSetting.length != arrayUniqueByKey.length) {
                    setError(`WorkLocationSetting`, {
                        message: '端末IDは重複して登録できません',
                        type: 'error'
                    });
                    return;
                } else {
                    providerSetting['WorkLocationSetting'] = {
                        UseIndividualSettings: true,
                        UseWorkLocation: !!workLocationSetting.UseWorkLocation,
                        IndividualSettings: workLocationSetting.IndividualSettings
                    }

                }
            } else {
                providerSetting['WorkLocationSetting'] = {
                    UseIndividualSettings: false,
                    UseWorkLocation: !!workLocationSetting.UseWorkLocation,
                    IndividualSettings: []
                }
            }
            providerSetting['WorkLocation'] = workLocationSetting.WorkLocation || ''

        } else {
            providerSetting['WorkLocationSetting'] = {
                UseIndividualSettings: false,
                UseWorkLocation: false,
                IndividualSettings: []
            }
            providerSetting['WorkLocation'] = ""
        }
        const newData = {
            ...orgInsertData
        }
        if (connectType == CONNECT_TYPE_V5) {
            newData['ProviderSetting'] = {
                ...providerSetting
            }
        }

        setInsertData(newData)
        /*     return;*/
        if (userInfo.isSuperAdmin) {
            setShowModalConfirm(true);
        } else {
            await updateOrgInfo(newData)
        }
    }

    const updateOrgInfo = async (data) => {
        setIsSubmit(true)
        await updateOrg(orgInfo.currentOrg.OrgId, data).then((res: any) => {
            toast.success("保存されました。");
            setOrgInfo({...orgInfo, currentOrg: res.currentOrgInfo.Attributes});
        }).catch(err => {
            toast.error("保存処理に失敗しました。再度お試しください。");
        }).finally(() => {
            if (userInfo.isSuperAdmin) {
                setShowModalConfirm(false)
            }
            setIsSubmit(false)
        })
    }

    const handleCloseModal = () => {
        setShowModalConfirm(false);
    }
    const handleCloseModalConfirmDelete = () => {
        setShowModalConfirmDelete(false);
    }

    const deleteRecord = () => {
        remove(currentSetting);
        setCurrentSetting(0);
        setShowModalConfirmDelete(false);
    }

    return (
        <Fragment>
            <Modal className="pt-5" show={showModalConfirmDelete} onHide={handleCloseModalConfirmDelete}>
                <Modal.Header closeButton>
                    <svg fill="#969492" xmlns="http://www.w3.org/2000/svg" className="info-icon me-2"
                         width="15px" height="15px" viewBox="0 0 52 52" enableBackground="new 0 0 52 52">
                        <path d="M26,2C12.7,2,2,12.7,2,26s10.7,24,24,24s24-10.7,24-24S39.3,2,26,2z M26,14.1c1.7,0,3,1.3,3,3s-1.3,3-3,3
                    s-3-1.3-3-3S24.3,14.1,26,14.1z M31,35.1c0,0.5-0.4,0.9-1,0.9h-3c-0.4,0-3,0-3,0h-2c-0.5,0-1-0.3-1-0.9v-2c0-0.5,0.4-1.1,1-1.1l0,0
                    c0.5,0,1-0.3,1-0.9v-4c0-0.5-0.4-1.1-1-1.1l0,0c-0.5,0-1-0.3-1-0.9v-2c0-0.5,0.4-1.1,1-1.1h6c0.5,0,1,0.5,1,1.1v8
                    c0,0.5,0.4,0.9,1,0.9l0,0c0.5,0,1,0.5,1,1.1V35.1z"/>
                    </svg>
                    確認
                </Modal.Header>
                <Modal.Body>この⁨⁩勤務場所コード、端末IDを削除しますか？</Modal.Body>
                <Modal.Footer className="modal-footer">
                    <Button variant="light" size="sm" className="modal-btn modal-cancel-btn"
                            onClick={handleCloseModalConfirmDelete}>
                        キャンセル
                    </Button>

                    <Button variant="danger" size="sm" className="modal-btn" onClick={deleteRecord}>
                        削除
                    </Button>

                </Modal.Footer>
            </Modal>

            <Modal className="pt-5" show={showModalConfirm} onHide={handleCloseModal}>
                <Modal.Header closeButton>

                </Modal.Header>
                <Modal.Body>更新してもよろしいでしょうか？</Modal.Body>
                <Modal.Footer className="modal-footer">
                    <Button variant="light" size="sm" className="modal-btn modal-cancel-btn" onClick={handleCloseModal}>
                        キャンセル
                    </Button>
                    {
                        isSubmit ?
                            <Button variant="primary" size="sm" className="modal-btn" disabled>
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                />
                                登録...
                            </Button>
                            :
                            <Button variant="primary" size="sm" className="modal-btn"
                                    onClick={() => updateOrgInfo(insertData)}>
                                更新
                            </Button>
                    }
                </Modal.Footer>
            </Modal>
            <div className="ts-setting">
                <PageHeader subTitle="ICカード連携の設定" title="共通設定"/>
                <Card className="mt-3 card-container">
                    {
                        orgInfo &&
                        <Form onSubmit={handleSubmit(submitFormData)}>
                            <input type="hidden" {...register(`UseTransportationExpense`)}/>
                            <input type="hidden" {...register(`CheckIdm`)}/>
                            <input type="hidden" {...register(`SoundMode`)}/>
                            <input type="hidden" {...register(`WorkLocationSetting.UseWorkLocation`)}/>
                            <div className="setting-card__header">
                                <span className="setting-card__title">設定</span>
                                <Button type="submit" className="setting-card__save" disabled={isSubmit}>
                                    {
                                        isSubmit && <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                        />
                                    }
                                    保存
                                </Button>
                            </div>
                            <div className="setting-card__body">
                                <SettingToggle
                                    id="useTransportationExpense-switch"
                                    label="IC交通費機能利用"
                                    checked={watchUseTransportationExpense == '1'}
                                    disabled={isEx}
                                    onChange={(checked) => setSwitchValue('UseTransportationExpense', checked)}
                                >
                                    <div className="setting-toggle__desc">チェックを外した場合はIC交通費機能にてICカードを読み込んでもエラーとなり利用出来ません。</div>
                                </SettingToggle>
                                <SettingToggle
                                    id="checkIdm-switch"
                                    label="ICカード即時チェック"
                                    checked={watchCheckIdm == '1'}
                                    disabled={isEx}
                                    onChange={(checked) => setSwitchValue('CheckIdm', checked)}
                                >
                                    <div className="setting-toggle__desc">チェックを入れると、ICカード内のIDm番号がTeamSpiritに存在するか確認します。</div>
                                    <div className="setting-toggle__desc">チェックを外すと、確認を行いません。</div>
                                    <div className="setting-toggle__desc">打刻時の処理速度を優先する場合は、チェックを外してください。</div>
                                </SettingToggle>
                                <SettingToggle
                                    id="soundMode-switch"
                                    label="打刻時音声モード"
                                    checked={watchSoundMode !== '0'}
                                    onChange={(checked) => setValue('SoundMode', (checked ? lastSoundMode : '0') as any, {shouldDirty: true})}
                                >
                                    <Form.Check
                                        inline
                                        label="効果音"
                                        type="radio"
                                        name="soundModeType"
                                        id="soundMode-radio-1"
                                        checked={(watchSoundMode === '0' ? lastSoundMode : watchSoundMode) === '1'}
                                        disabled={watchSoundMode === '0'}
                                        onChange={() => setValue('SoundMode', '1' as any, {shouldDirty: true})}
                                        className="checkbox-label me-2 radio-form-check"
                                    />
                                    <Form.Check
                                        inline
                                        label="メッセージ音声"
                                        type="radio"
                                        name="soundModeType"
                                        id="soundMode-radio-2"
                                        checked={(watchSoundMode === '0' ? lastSoundMode : watchSoundMode) === '2'}
                                        disabled={watchSoundMode === '0'}
                                        onChange={() => setValue('SoundMode', '2' as any, {shouldDirty: true})}
                                        className="checkbox-label me-2 radio-form-check"
                                    />
                                </SettingToggle>
                                {
                                    connectType == CONNECT_TYPE_V5 &&
                                    <SettingToggle
                                        id="useWorkLocation-switch"
                                        label="勤務場所設定"
                                        checked={watchUseWorkLocation == '1'}
                                        onChange={(checked) => setValue('WorkLocationSetting.UseWorkLocation', (checked ? '1' : '0') as any, {shouldDirty: true})}
                                        action={watchUseWorkLocation == '1' && (
                                            <button
                                                type="button"
                                                className={`setting-toggle__caret ${workLocationExpanded ? '' : 'setting-toggle__caret--collapsed'}`}
                                                aria-expanded={workLocationExpanded}
                                                onClick={() => setWorkLocationExpanded(!workLocationExpanded)}>
                                                <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M1 6.5L6 1.5L11 6.5" stroke="#444444" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                                                </svg>
                                            </button>
                                        )}
                                    >
                                        {watchUseWorkLocation == '1' && workLocationExpanded &&
                                        <div className="work-location">
                                            <div className="work-location__row">
                                                <div className="work-location__field col-4">
                                                    <label className="work-location__label"
                                                           htmlFor="work-location-code">勤務場所コード</label>
                                                    <div className="d-flex align-items-center">
                                                        <Form.Control
                                                            id="work-location-code"
                                                            style={{maxWidth:"300px"}}
                                                            className={`work-location__input ${errors[`WorkLocationSetting.WorkLocation`] ? 'error' : ''}`}
                                                            placeholder="端末ID-A"
                                                            {...register(`WorkLocationSetting.WorkLocation`)}
                                                        />
                                                        {
                                                            watchUseIndividualSettings &&
                                                            <span className="label-default-worklocation ms-2">デフォルト</span>
                                                        }
                                                    </div>
                                                </div>
                                                <Form.Check className="work-location__check mb-0">
                                                    <Form.Check.Input
                                                        type="checkbox"
                                                        id={`form-add-setting`}
                                                        {...register(`WorkLocationSetting.UseIndividualSettings`)}
                                                    />
                                                    <Form.Check.Label htmlFor={`form-add-setting`}>個別の設定を追加する</Form.Check.Label>
                                                </Form.Check>
                                            </div>
                                            <ErrorMessage
                                                name={`WorkLocationSetting.WorkLocation`}
                                                className={"px-0 pt-1 mb-0"}
                                                errors={errors}/>
                                            {
                                                watchUseIndividualSettings &&
                                                <div className="work-location__individual col-6">
                                                    <div className="work-location__individual-title">個別の設定</div>
                                                    <div className="work-location__note">
                                                        <p className="mb-0">※複数端末を登録する場合は、必ず端末IDを設定してください。</p>
                                                        <p className="mb-0">端末IDが登録されてない端末からの打刻はデフォルトの勤務場所コードが適用されます。</p>
                                                        <p className="mb-0">※端末IDはPitTouch端末の端末情報表示にて確認できます。</p>
                                                    </div>
                                                    {
                                                        fieldWorkLocationSetting.map((item, index) => (
                                                            <div className="work-location__item" key={item.id || index}>
                                                                <div className="work-location__item-fields">
                                                                    <div className="work-location__field col-4">
                                                                        {index == 0 && <label className="work-location__label">勤務場所コード</label>}
                                                                        <Form.Control
                                                                            className="work-location__input"
                                                                            {...register(`WorkLocationSetting.IndividualSettings.${index}.WorkLocation`)}
                                                                        />
                                                                    </div>
                                                                    <div className="work-location__field col-4">
                                                                        {index == 0 && <label className="work-location__label">端末ID</label>}
                                                                        <Form.Control
                                                                            className="work-location__input"
                                                                            {...register(`WorkLocationSetting.IndividualSettings.${index}.DeviceId`)}
                                                                        />
                                                                    </div>
                                                                    {
                                                                        index != 0 &&
                                                                        <a onClick={() => {
                                                                            setShowModalConfirmDelete(true);
                                                                            setCurrentSetting(index)
                                                                        }}
                                                                           className="btn-remove-worklocation">削除する</a>
                                                                    }
                                                                </div>
                                                                <ErrorMessage
                                                                    name={`WorkLocationSetting.IndividualSettings[${index}].DeviceId`}
                                                                    className={"px-0 pt-1 mb-0"}
                                                                    errors={errors}/>
                                                                <ErrorMessage
                                                                    name={`WorkLocationSetting.IndividualSettings[${index}].WorkLocation`}
                                                                    className={"px-0 pt-1 mb-0"}
                                                                    errors={errors}/>
                                                            </div>
                                                        ))
                                                    }
                                                    <ErrorMessage
                                                        name={`WorkLocationSetting`}
                                                        className={"px-0 pt-1 mt-2 mb-0"}
                                                        errors={errors}/>
                                                    <button type={'button'}
                                                            onClick={() => append({
                                                                WorkLocation: '',
                                                                DeviceId: ''
                                                            })}
                                                            className={'btn btn-add-setting work-location__add d-flex align-items-center justify-content-center'}>
                                                        <svg width="10" height="11" viewBox="0 0 10 11"
                                                                             fill="none"
                                                                             xmlns="http://www.w3.org/2000/svg">
                                                                            <path
                                                                                d="M5.90915 6.54288H9.65933C9.74924 6.54145 9.83506 6.5051 9.89864 6.44152C9.96222 6.37794 9.99857 6.29211 10 6.20221V5.52017C9.99857 5.43026 9.96222 5.34444 9.89864 5.28085C9.83506 5.21727 9.74924 5.18092 9.65933 5.17949H5.90915C5.87886 5.18131 5.84852 5.17668 5.82014 5.16591C5.79176 5.15514 5.76599 5.13847 5.74452 5.11701C5.72306 5.09555 5.70639 5.06977 5.69562 5.0414C5.68485 5.01302 5.68022 4.98268 5.68204 4.95238V1.20151C5.68061 1.11161 5.64426 1.02578 5.58068 0.9622C5.5171 0.898618 5.43127 0.862267 5.34137 0.86084H4.65933C4.56942 0.862267 4.4836 0.898618 4.42001 0.9622C4.35643 1.02578 4.32008 1.11161 4.31865 1.20151V4.95169C4.32047 4.98199 4.31584 5.01233 4.30507 5.0407C4.2943 5.06908 4.27763 5.09485 4.25617 5.11632C4.23471 5.13778 4.20893 5.15445 4.18056 5.16522C4.15218 5.17599 4.12184 5.18062 4.09154 5.1788H0.340673C0.250648 5.18023 0.164722 5.21668 0.101122 5.28041C0.0375211 5.34414 0.00124912 5.43014 0 5.52017V6.20221C0.00142736 6.29211 0.037778 6.37794 0.10136 6.44152C0.164942 6.5051 0.250766 6.54145 0.340673 6.54288H4.09085C4.12115 6.54106 4.15149 6.54569 4.17986 6.55646C4.20824 6.56723 4.23401 6.5839 4.25548 6.60536C4.27694 6.62683 4.29361 6.6526 4.30438 6.68098C4.31515 6.70935 4.31978 6.7397 4.31796 6.76999V10.5202C4.31939 10.6101 4.35574 10.6959 4.41932 10.7595C4.4829 10.8231 4.56873 10.8594 4.65863 10.8608H5.34067C5.43058 10.8594 5.51641 10.8231 5.57999 10.7595C5.64357 10.6959 5.67992 10.6101 5.68135 10.5202V6.76999C5.67952 6.73963 5.68417 6.70923 5.69498 6.6808C5.70579 6.65237 5.72252 6.62656 5.74406 6.60509C5.7656 6.58362 5.79146 6.56696 5.81992 6.55624C5.84838 6.54551 5.8788 6.54096 5.90915 6.54288Z"
                                                                                fill="#0070D2"/>
                                                                        </svg>
                                                        <span className="ms-2">追加</span>
                                                    </button>
                                                </div>
                                            }
                                        </div>
                                        }
                                    </SettingToggle>
                                }
                            </div>
                        </Form>
                    }

                </Card>
            </div>
        </Fragment>
    )

}